import React, { useState } from 'react';
import Video from '../../../videos/video.mp4';
import { Button } from '../../ButtonElement';
import MaPhoto from '../../../images/moi.jpg';
import {
    PresentationContainer,
    PresentationWrapper,
    PresentationRow,
    PresentationBg,
    VideoBg,
    Column1,
    Column2,
    TextWrapper,
    TopLine,
    Heading,
    Subtitle,
    ImgWrap,
    Img,
    PresentationBtnWrapper,
    ArrowForward,
    ArrowRight
} from './PresentationElements';

const PresentationSection = () => {
    const [hover, setHover] = useState(false)

    const onHover = () => {
        setHover(!hover)
    }

    return (
        <PresentationContainer className="lightColor darkBackground">
            <PresentationWrapper>
                <PresentationRow>
                    <Column1>
                        <TextWrapper>
                            <Heading>Maëva Fortune</Heading>
                            <TopLine className="primaryColor">Etudiante en informatique</TopLine>
                            <Subtitle>Actuellement en 2ème année d'IUT informatique à <strong>Bordeaux</strong>.
                            Je suis à la recherche d'une opportunité de <strong>stage</strong> dans le secteur de l'informatique
                            pour développer davantage mon expertise.
                            </Subtitle>
                            <PresentationBtnWrapper>
                                <Button to="contact" onMouseEnter={onHover} onMouseLeave={onHover}
                                    smooth={true} duration={500}
                                    spy={true} exact='true' offset={-80}>Contact {hover ? <ArrowForward /> : <ArrowRight />}
                                </Button>
                            </PresentationBtnWrapper>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img src={MaPhoto} alt="ma photo" />
                        </ImgWrap>
                    </Column2>
                </PresentationRow>
            </PresentationWrapper>
            <PresentationBg>
                <VideoBg autoPlay loop muted src={Video} type='video/mp4' className="videoBackground" />
            </PresentationBg>
        </PresentationContainer>

    )
}

export default PresentationSection
